export default __webpack_public_path__ + "static/STT-company-profile-sewing-thread-932b7ef1609756768398799524799d68.pdf";